import styled from '@emotion/styled';
import { spacing, sizing } from '@mui/system';

const getBackgroundColor = ({
  theme, disabled, isDragAccept, isDragReject, error = false,
}) => {
  if (disabled) {
    return theme.palette.grey[0];
  }
  if (isDragAccept) {
    return theme.palette.success[5];
  }
  if (isDragReject || error) {
    return theme.palette.alert.light;
  }
  return theme.palette.primary[0];
};

const getBorderColor = ({
  theme, disabled, isDragAccept, isDragReject, error = false,
}) => {
  if (disabled) {
    return theme.palette.grey[40];
  }
  if (isDragAccept) {
    return theme.palette.success.main;
  }
  if (isDragReject || error) {
    return theme.palette.error.main;
  }
  return theme.palette.primary.main;
};

export const DropzoneSubtitle = styled.p`
  line-height: 1.75;
  font-size: 1.4rem;
  color: #071f29;
  font-family: 'Open Sans', sans-serif;
  &:first-of-type {
    font-weight: 600;
  }
`;

// Should be used with and accepts props from getRootProps returned from the useDropzone hook.
// See https://github.com/react-dropzone/react-dropzone for details.
export const Dropzone = styled.div`
  background-color: ${getBackgroundColor};
  border: 1px dashed ${getBorderColor};
  ${({ theme, isDragReject, error }) => `
    border-radius: ${theme.shape.borderRadius}px;
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: ${theme.spacing(5)};
    padding: ${theme.spacing(5)};
    height: auto;
    position: relative;
    text-align: center;
    transition: background .25s ease-in-out, border .25s ease-in-out;
    ${DropzoneSubtitle} {
      color: ${isDragReject || error ? theme.palette.common.red : 'inherit'};
    }
  `}
  ${spacing}
  ${sizing}
`;
